import React, { Component } from 'react';
import { connect } from 'react-redux';

import { formatDate } from '../../../utils/date-utils';

import { getCurrentCampaign } from '../campaign.selectors';
import Table from '../../common/components/Table';

class PrizeStoreAdminBlock extends Component {

  renderHeader = () => {
    return (
      <tr>
        <th>Kauppa aukeaa:</th>
        <th>Kauppa sulkeutuu:</th>
      </tr>
    );
  }

  renderItem = (campaign, index) => {
    const { prizeShopStartDate, prizeShopEndDate } = campaign;
    return (
      <tr key={index}>
        <td>{formatDate(prizeShopStartDate)}</td>
        <td>{formatDate(prizeShopEndDate)}</td>
      </tr>
    );
  }

  render(){
    const { currentCampaign } = this.props;
    if(!currentCampaign) return null;
    return (
      <Table
        items={[currentCampaign]}
        renderHeader={this.renderHeader}
        renderItem={this.renderItem}
      />
    );
  }
};

const mapStateToProps = (state) => {
  const currentCampaign = getCurrentCampaign(state);
  return {
    currentCampaign,
  };
};

const ConnectedPrizeStoreAdminBlock = connect(
  mapStateToProps,
  null,
)(PrizeStoreAdminBlock);

export default ConnectedPrizeStoreAdminBlock;


// WEBPACK FOOTER //
// ./src/modules/campaign/components/PrizeStoreAdminBlock.js